<template>
  <b-table
    :data="documents"
    :loading="loading"
    :hoverable="true"
    paginated
    backend-pagination
    :pagination-simple="true"
    pagination-position="both"
    :total="total"
    :per-page="pageSize"
    :sort-icon="'arrow-up'"
    @page-change="onPageChange"
    detailed
    checkable
    :checkbox-position="checkboxPosition"
    :checked-rows.sync="checkedRows"
    class="documents-list"
    detail-key="cirrus_id"
  >

    <template slot-scope="props">
      <b-table-column label="UPC / Cirrus ID" field="id">
        <a @click.prevent="onUpcClicked(props.row.upc)">
          {{ props.row.upc }}
        </a>
        <br/>
        <small>{{props.row.cirrus_id}}</small>
      </b-table-column>
      <b-table-column label="Filename">
        {{props.row.filename}}
      </b-table-column>
      <b-table-column label="Revision" :custom-sort="(a,b,asc)=>onSort('revision',asc)" sortable>
        {{props.row.revision}}
      </b-table-column>
      <b-table-column label="Priority">
        {{ props.row.task_priority || '' }}
      </b-table-column>
      <b-table-column label="Status">
        <b-tooltip :label="props.row.task_error" type="is-dark">
          <b-taglist attached>
            <b-tag :type="tagType(props.row.status)">
              {{ props.row.status }}
            </b-tag>
          </b-taglist>
        </b-tooltip>
      </b-table-column>
      <b-table-column label="Worker" nowrap :custom-sort="(a,b,asc)=>onSort('task_worker', asc)" sortable>
        <b-tag>
          {{ (props.row.task_worker || '').replace('.local', '')}}
        </b-tag>
      </b-table-column>
      <b-table-column label="Enqueued" nowrap :custom-sort="(a,b,asc)=>onSort('task_enqueued',asc)" sortable>
        <b-tooltip v-if="props.row.task_enqueued" :label="formatDate(props.row.task_enqueued)" type="is-dark" dashed>
          {{ humanReadableDate(props.row.task_enqueued) }} ago
        </b-tooltip>
      </b-table-column>
      <b-table-column label="Created" nowrap :custom-sort="(a,b,asc)=>onSort('created',asc)" sortable>
        <b-tooltip v-if="props.row.created" :label="formatDate(props.row.created)" type="is-dark" dashed>
          {{ humanReadableDate(props.row.created) }} ago
        </b-tooltip>
      </b-table-column>
    </template>

    <template slot="detail" slot-scope="props">
      <document-details :doc="props.row" />
    </template>
    <template slot="top-left" >
      <b>Total checked </b>: {{ checkedRows.length }}
      <b-button
        style="margin-left: 10px"
        :icon-left="loading ? 'loading mdi-spin' : 'restart'"
        @click="requeue">Requeue</b-button>
    </template>
    <template v-if="!loading" slot="bottom-left" >
      <b>Total checked </b>: {{ checkedRows.length }}
      <b-button
        style="margin-left: 10px"
        :icon-left="loading ? 'loading mdi-spin' : 'restart'"
        @click="requeue">Requeue</b-button>
    </template>
  </b-table>
</template>

<script>
  import format from 'date-fns/format'
  import formatDistanceToNow from "date-fns/formatDistanceToNow"
  import parseISO from "date-fns/parseISO"
  import DocumentDetails from '../components/DocumentDetails'
  import { getLogs, requeueDocuments } from '../api'

  export default {
    name: "Documents",
    components: { DocumentDetails },
    props: {
      documents: { type: Array, default: () => [] },
      total: { type: Number, default: 0 },
      pageSize: { type: Number, default: 40 },
      loading: { type: Boolean, default: false },
    },
    data(){
      return{
        checkedRows: [],
        checkboxPosition: 'right'
      }
    },
    methods: {
      async requeue() {
        let docs = []
        this.checkedRows.map(e=>{
          docs.push(e.cirrus_id)
        })
        this.checkedRows = []
        try {
          await requeueDocuments(docs)
          this.$emit('requeued-docs')
          this.$buefy.toast.open(`Requeued documents`)
        } catch {
          this.$buefy.toast.open({
            message: `Failed requeuing documents. An error occurred.`,
            type: 'is-danger'
          })
        }
      },
      onPageChange(page) {
        this.$emit('page-change', page)
      },
      async onDetailsOpened (doc) {
        if (doc.busyLoadingLogs || (doc.logs && doc.logs.length)) {
          return
        }

        doc.busyLoadingLogs = true
        try {
          doc.logs = await getLogs(doc.task_id) // eslint-disable-line
        } catch (e) {
          // eslint-disable-next-line
          doc.logs = [{
            _id: 'guwno',
            message: 'Failed loading logs.',  // show just this text instead of an error toast
            timestamp: ''
          }]
        }
        doc.busyLoadingLogs = false // eslint-disable-line
      },
      onSort(name, asc) {
        const orderingParam = asc ? name : `-${name}`
        this.$emit('ordering-change', orderingParam)
      },
      onUpcClicked(upc) {
        this.$emit('selected-upc', upc)
      },
      humanReadableDate (dateStr) {
        const dt = parseISO(dateStr)
        return formatDistanceToNow(dt)
      },
      formatDate (dateStr) {
        const dt = parseISO(dateStr)
        return format(dt, 'yyy-MM-dd HH:mm:ss')
      },
      tagType (status) {
        const tagTypes = {
          pending: 'is-default',
          processing: 'is-primary',
          processed: 'is-success',
          failed: 'is-warning'
        }
        return tagTypes[status]
      }
    }
  }
</script>


<style>
  small {
    font-size: 0.75em;
    opacity: 0.25;
  }
  .detail section {
    margin-bottom: 20px;
  }
  .documents-list .checkbox-cell .b-checkbox {
    opacity: 0.3;
  }
  .documents-list tr:hover .checkbox-cell .b-checkbox {
    opacity: 1;
  }
</style>
